import { Routes, Route } from 'react-router-dom';
import { Navigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import ClubPerformanceContextRoutes from './ClubPerformanceContextRoutes';

import ClubPerformanceOrgUnitSelection from './clubPerformanceOrgUnitSelection/ClubPerformanceOrgUnitSelection';

import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';

import SelectOrgUnitContextProvider from "@usas/ui-web/state/selectOrgUnit/SelectOrgUnitContextProvider";
import PersonOrgRoleContextProvider from '@usas/ui-web/state/personOrgRole/PersonOrgRoleContextProvider';

const BasicRoutes = ({ navRoutes }) => (
  <Routes>
    <Route path={navRoutes.CLUB_PERFORMANCE_SELECTION?.path}
      element={
        <SecuredRouteElement
          navRoute={navRoutes.CLUB_PERFORMANCE_SELECTION}
          editElement={<ClubPerformanceOrgUnitSelection />} />
      } />

    <Route path={'/*'} element={<ClubPerformanceContextRoutes navRoutes={navRoutes} />} />
    <Route path={'/'} element={<Navigate to={navRoutes.CLUB_PERFORMANCE_SELECTION?.route} replace />} />
  </Routes>
);

const ClubPerformanceBasicRoutes = ({ navRoutes }) => (
  <PersonOrgRoleContextProvider>
    <SelectOrgUnitContextProvider>
      <BasicRoutes navRoutes={navRoutes} />
    </SelectOrgUnitContextProvider>
  </PersonOrgRoleContextProvider>
);

export default ClubPerformanceBasicRoutes;